import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type PublicPayLinkGrowerFieldsFragment = { __typename?: 'PublicInvoicePayLinkGrower', displayName: string, logoUrl?: string | null, primaryColorHex?: string | null, email?: string | null, phone?: string | null };

export type PublicPayLinkFieldsFragment = { __typename?: 'PublicInvoicePayLink', tokenState: Types.PublicInvoicePayLinkTokenState, onlinePaymentAvailable: boolean, newLinkAvailable: boolean, grower?: { __typename?: 'PublicInvoicePayLinkGrower', displayName: string, logoUrl?: string | null, primaryColorHex?: string | null, email?: string | null, phone?: string | null } | null, invoice?: { __typename?: 'PublicInvoicePayLinkInvoice', invoiceNumber: string, invoiceDate: Types.TDateISO, dueDate: Types.TDateISO, currency: string, total: number, postedBalance: number, pendingAmount: number, lastFailure?: string | null, openAttemptStatus?: Types.PaymentAttemptStatus | null, quote: { __typename?: 'InvoicePaymentQuote', postedBalance: number, discount: number, lateCharge: number, payableAmount: number, currency: string, quotedAt: Types.TDateISO, expiresAt: Types.TDateISO } } | null };

export type PublicInvoicePayLinkQueryVariables = Types.Exact<{
  token: Types.Scalars['String']['input'];
}>;


export type PublicInvoicePayLinkQuery = { __typename?: 'Query', publicInvoicePayLink: { __typename?: 'PublicInvoicePayLink', tokenState: Types.PublicInvoicePayLinkTokenState, onlinePaymentAvailable: boolean, newLinkAvailable: boolean, grower?: { __typename?: 'PublicInvoicePayLinkGrower', displayName: string, logoUrl?: string | null, primaryColorHex?: string | null, email?: string | null, phone?: string | null } | null, invoice?: { __typename?: 'PublicInvoicePayLinkInvoice', invoiceNumber: string, invoiceDate: Types.TDateISO, dueDate: Types.TDateISO, currency: string, total: number, postedBalance: number, pendingAmount: number, lastFailure?: string | null, openAttemptStatus?: Types.PaymentAttemptStatus | null, quote: { __typename?: 'InvoicePaymentQuote', postedBalance: number, discount: number, lateCharge: number, payableAmount: number, currency: string, quotedAt: Types.TDateISO, expiresAt: Types.TDateISO } } | null } };

export type PublicInvoicePaymentAttemptQueryVariables = Types.Exact<{
  attemptId: Types.Scalars['String']['input'];
  secret: Types.Scalars['String']['input'];
}>;


export type PublicInvoicePaymentAttemptQuery = { __typename?: 'Query', publicInvoicePaymentAttempt?: { __typename?: 'InvoicePaymentAttempt', attemptId: string, status: Types.PaymentAttemptStatus, total: number, currency: string, lastFailure?: string | null, invoices: Array<{ __typename?: 'InvoicePaymentAttemptInvoice', invoiceId: string, allocatedAmount: number, appliedAmount: number, unappliedCreditAmount: number, discountApplied: number, state: Types.InvoicePaymentAllocationState }> } | null };

export const PublicPayLinkGrowerFieldsFragmentDoc = new TypedDocumentString(`
    fragment PublicPayLinkGrowerFields on PublicInvoicePayLinkGrower {
  displayName
  logoUrl
  primaryColorHex
  email
  phone
}
    `, {"fragmentName":"PublicPayLinkGrowerFields"});
export const PublicPayLinkFieldsFragmentDoc = new TypedDocumentString(`
    fragment PublicPayLinkFields on PublicInvoicePayLink {
  tokenState
  onlinePaymentAvailable
  newLinkAvailable
  grower {
    ...PublicPayLinkGrowerFields
  }
  invoice {
    invoiceNumber
    invoiceDate
    dueDate
    currency
    total
    postedBalance
    pendingAmount
    lastFailure
    openAttemptStatus
    quote {
      postedBalance
      discount
      lateCharge
      payableAmount
      currency
      quotedAt
      expiresAt
    }
  }
}
    fragment PublicPayLinkGrowerFields on PublicInvoicePayLinkGrower {
  displayName
  logoUrl
  primaryColorHex
  email
  phone
}`, {"fragmentName":"PublicPayLinkFields"});
export const PublicInvoicePayLinkDocument = new TypedDocumentString(`
    query PublicInvoicePayLink($token: String!) {
  publicInvoicePayLink(token: $token) {
    ...PublicPayLinkFields
  }
}
    fragment PublicPayLinkGrowerFields on PublicInvoicePayLinkGrower {
  displayName
  logoUrl
  primaryColorHex
  email
  phone
}
fragment PublicPayLinkFields on PublicInvoicePayLink {
  tokenState
  onlinePaymentAvailable
  newLinkAvailable
  grower {
    ...PublicPayLinkGrowerFields
  }
  invoice {
    invoiceNumber
    invoiceDate
    dueDate
    currency
    total
    postedBalance
    pendingAmount
    lastFailure
    openAttemptStatus
    quote {
      postedBalance
      discount
      lateCharge
      payableAmount
      currency
      quotedAt
      expiresAt
    }
  }
}`);
export const PublicInvoicePaymentAttemptDocument = new TypedDocumentString(`
    query PublicInvoicePaymentAttempt($attemptId: String!, $secret: String!) {
  publicInvoicePaymentAttempt(attemptId: $attemptId, secret: $secret) {
    attemptId
    status
    total
    currency
    lastFailure
    invoices {
      invoiceId
      allocatedAmount
      appliedAmount
      unappliedCreditAmount
      discountApplied
      state
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    PublicInvoicePayLink: build.query<PublicInvoicePayLinkQuery, PublicInvoicePayLinkQueryVariables>({
      query: (variables) => ({ document: PublicInvoicePayLinkDocument, variables })
    }),
    PublicInvoicePaymentAttempt: build.query<PublicInvoicePaymentAttemptQuery, PublicInvoicePaymentAttemptQueryVariables>({
      query: (variables) => ({ document: PublicInvoicePaymentAttemptDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { usePublicInvoicePayLinkQuery, useLazyPublicInvoicePayLinkQuery, usePublicInvoicePaymentAttemptQuery, useLazyPublicInvoicePaymentAttemptQuery } = injectedRtkApi;
